<!--  -->
<template>
  <div class>
    <el-dialog
      title="纠错反馈"
      align="center"
      @close="handleClose"
      :visible.sync="dialogVisible"
      width="640px"
    >
      <div class="paper">
        <h5 class="title">学者信息</h5>
        <p>
          <span class="title">所属榜单：</span>
          {{errorObj.substr}}
        </p>
        <p>
          <span class="title">学者姓名：</span>
          {{errorObj.iname?errorObj.iname:errorObj.name}}
        </p>
        <p>
          <span class="title">学者单位：</span>
          {{errorObj.company}}
        </p>
        <p>
          <span class="title">主要领域：</span>
          {{errorObj.ikeywords}}
        </p>
        <p>
          <span class="title">代表作：</span>
          {{errorObj.title}}
        </p>
        <h5 class="title mt30">纠错反馈内容</h5>
        <el-checkbox-group class="mt20" v-model="errorForm.checkList">
          <el-checkbox label="学者信息有误"></el-checkbox>
          <el-checkbox label="学者作品有误"></el-checkbox>
          <el-checkbox v-model="qt" label="其他"></el-checkbox>
        </el-checkbox-group>
        <el-input class="mt20 mb20" type="textarea" v-model="errorForm.desc"></el-input>反馈人
        <el-input class="mr20 ml5" style="width:210px" v-model="errorForm.name"></el-input>联系电话
        <el-input class="ml5" style="width:210px" v-model="errorForm.phone"></el-input>
        <div class="mt50" style="text-align:center">
          <a @click="submitForm" class="error-btn">提交反馈</a>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      dialogVisible: false,
      data: {},
      errorObj: {},
      qt: 3,
      errorForm: {
        checkList: [],
        desc: "",
        name: "",
        phone: "",
        fbtype: ""
      }
    };
  },
  props: ["errorValue"],
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    open(obj, str) {
      this.dialogVisible = true;
      this.errorObj = obj;
      this.errorObj.substr = str;
      //   this.$nextTick(() => {
      console.log(this.errorObj);

      //   });
    },
    handleClose() {
      console.log(this.dialogVisible);
    },
    checkType(text) {
      switch (text) {
        case "学者信息有误":
          return 1;
        case "学者作品有误":
          return 2;
        case "其他":
          return 3;
        default:
          break;
      }
    },
    submitForm() {
      let s = "";
      this.errorForm.checkList.forEach(item => {
        s += this.checkType(item) + ",";
      });

      s = s.substring(0, s.lastIndexOf(","));
      console.log(s);
      this.errorForm.fbtype = s;
      this.addfeedback(this.errorForm);
      //console.log(this.errorForm)
    },
    addfeedback(obj) {
      if (obj.desc != "") {
        let _this = this;
        let params = {
          mid: "",
          name: obj.name,
          phone: obj.phone,
          description: obj.desc,
          fbtype: obj.fbtype
        };
        _this.$api
          .fetchPost("/iseapi/addfeedback", params)
          .then(res => {
            console.log(res);
            if (res.msg == "success") {
              _this.errorForm = {
                checkList: [],
                desc: "",
                name: "",
                phone: "",
                fbtype: ""
              };
              _this.dialogVisible = false;
              _this.openEz();
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.openNR();
      }
    },
    openEz() {
      const h = this.$createElement;
      this.$message({
        message: h("p", null, [h("span", null, "反馈提交成功，感谢您的关注")]),
        offset: 100
      });
    },
    openNR() {
      const h = this.$createElement;
      this.$message({
        message: h("p", null, [h("span", null, "提交内容不可以为空")]),
        offset: 100
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style>
.mb20 {
  margin-bottom: 20px;
}
.mt20 {
  margin-top: 20px;
}
.mr20 {
  margin-right: 20px;
}
.ml5 {
  margin-left: 5px;
}
.mt50 {
  margin-top: 50px;
}
.paper {
  text-align: left;
  padding: 0 20px;
}
.paper h5 {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
}
.paper .rdfyk {
  color: #4267b2;
}
.paper .rdfyk::before {
  content: " ";
  background: url("../../assets/rdfyk.svg") no-repeat;
  background-size: 100%;
  margin-right: 5px;
  position: relative;
  top: 2px;
  display: inline-block;
  height: 14px;
  width: 16px;
}
.paper .error-btn {
  background-color: #4267b2;
  color: #fff;
  padding: 10px 15px;
  border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/view/common/papererror.vue